<template>
    <div id="vMenu">
        <div class="list-group list-group-flush panel">
            <b-link
                class="list-group-item item"
                :active="$route.name === 'input'"
                @click="$router.push({ name: 'input' })"
            >
                <i class="fa-fw fal fa-pencil menu-icon"></i>
                Saisie
            </b-link>
            <b-link
                class="list-group-item item"
                :active="$route.name === 'notAffected'"
                @click="$router.push({ name: 'notAffected' })"
            >
                <i class="fa-fw fal fa-pencil menu-icon"></i>
                Temps non affectés
            </b-link>
            <b-link
                class="list-group-item item"
                :active="$route.name === 'accountingFirmUserWeek'"
                @click="$router.push({ name: 'accountingFirmUserWeek' })"
            >
                <i class="fa-fw fal fa-table menu-icon"></i>
                Synthèse hebdo
                <span v-if="viewAllTimeSheets">collaborateur</span>
            </b-link>

            <b-link
                class="list-group-item item"
                :active="$route.name === 'accountingFirmUserYear'"
                @click="$router.push({ name: 'accountingFirmUserYear' })"
            >
                <i class="fa-fw fal fa-table menu-icon"></i>
                Synthèse annuelle
                <span v-if="viewAllTimeSheets">collaborateur</span>
            </b-link>

            <b-link
                class="list-group-item item"
                :active="$route.name === 'clientYear'"
                @click="$router.push({ name: 'clientYear' })"
            >
                <i class="fa-fw fal fa-table menu-icon"></i>
                Synthèse annuelle client
            </b-link>

            <div v-if="viewAllTimeSheets">
                <b-link
                    class="list-group-item item"
                    :active="$route.name === 'inputWeekControl'"
                    @click="$router.push({ name: 'inputWeekControl' })"
                >
                    <i class="fa-fw fal fa-calendar-check menu-icon"></i>
                    Contrôle saisie hebdo
                </b-link>
                <b-link
                    class="list-group-item item"
                    :active="$route.name === 'inputAccountingFirmUserControl'"
                    @click="
                        $router.push({ name: 'inputAccountingFirmUserControl' })
                    "
                >
                    <i class="fa-fw fal fa-calendar-check menu-icon"></i>
                    Contrôle saisie collaborateur
                </b-link>
            </div>

            <div v-if="showDashboard && 1 === 0">
                <b-link
                    class="list-group-item item"
                    :active="$route.name === 'pivot'"
                    @click="$router.push({ name: 'pivot' })"
                >
                    <i class="fa-fw fal fa-table menu-icon"></i>
                    Tableau croisé dynamique
                </b-link>
            </div>

            <div v-if="viewAllTimeSheets || isBiller">
                <b-list-group-item href="#" class="item">
                    <b-row>
                        <b-col sm="7" class="pt-1">
                            <i class="fa-fw fal fa-file-excel menu-icon"></i>
                            Export Excel
                        </b-col>
                        <b-col sm="5">
                            <b-form-select
                                v-model="exportYear"
                                :options="yearOptions"
                                class="text-dark"
                                size="sm"
                                @change="excelExport"
                            >
                                <template #first>
                                    <b-form-select-option
                                        :value="null"
                                        disabled
                                    >
                                        -- Année --
                                    </b-form-select-option>
                                </template>
                            </b-form-select>
                        </b-col>
                    </b-row>
                </b-list-group-item>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
    name: 'TimeSheetsVerticalMenu',

    props: {
        initialDate: {
            type: String,
            required: false,
            default: null,
        },
    },

    data() {
        return {
            exportYear: null,
            yearOptions: [],
        }
    },

    computed: {
        ...mapState({
            pageName: (state) => state.browsing.pageName,
            showVerticalMenu: (state) => state.timeSheetsVM.showVerticalMenu,
            menuRoutes: (state) => state.timeSheetsVM.menuRoutes,
            viewAllTimeSheets: (state) => state.timeSheetsVM.viewAllTimeSheets,
            showDashboard: (state) => state.timeSheetsVM.showDashboard,
            isBiller: (state) => state.timeSheetsVM.isBiller,
        }),

        currentYear() {
            return new Date().getFullYear()
        },
    },

    async created() {
        this.setDate()
        await this.$store.dispatch('timeSheetsVM/getRoutes')
        this.$store.commit(
            'timeSheetsVM/SET_VIEW_ALL_TIME_SHEETS',
            this.menuRoutes.viewAllTimeSheets
        )
        this.$store.commit(
            'timeSheetsVM/SET_SHOW_DASHBOARD',
            this.menuRoutes.showDashboard
        )
        this.$store.commit(
            'timeSheetsVM/SET_IS_BILLER',
            this.menuRoutes.isBiller
        )
        this.$store.commit('timeSheetsVM/SHOW_VERTICAL_MENU')
        this.setYearOptions()
    },

    methods: {
        setDate() {
            const initialDate =
                this.initialDate === null
                    ? this.$moment().format('Y-MM-DD')
                    : this.initialDate
            this.$store.commit('timeSheetsVM/SET_CURRENT_DATE', initialDate)
        },

        setPageName(pageName) {
            this.$store.commit('browsing/SET_PAGE_NAME', pageName)
        },

        setYearOptions() {
            this.yearOptions = [
                { text: this.currentYear, value: this.currentYear },
                {
                    text: (this.currentYear - 1).toString(),
                    value: this.currentYear - 1,
                },
                {
                    text: (this.currentYear - 2).toString(),
                    value: this.currentYear - 2,
                },
                {
                    text: (this.currentYear - 3).toString(),
                    value: this.currentYear - 3,
                },
            ]
        },

        excelExport() {
            window.location = `${this.menuRoutes.export}/${this.exportYear}`
        },
    },
}
</script>

<style scoped></style>
